<template>
  <!-- 获取方案 -->
  <div class="GetScheme" v-if="showScheme">
    <div class="SchemeBox">
      <div class="SchemeTitle">
        获取方案信息填写
        <p class="closeBtn" @click="closeBtn"><img src="../../img/close.png" alt=""></p>
      </div>
      <form :model="form" @submit.prevent="submit">
        <div class="schemeIpt">
          <div  class="schemeIptLeft"> <span>*</span> 手机号</div>
          <input type="text" :class="{showHint}" v-model.trim="form.Phone "  placeholder="  请输入手机号" required @blur="leave(form.Phone )" @focus="getIpt"> 
        </div>
        <!-- <div class="schemeIpt">
          <input type="text" v-model.trim="form.verify"  placeholder="  请输入验证码">
          <button class="getVerify">获取验证码</button>
        </div> -->
        <div class="schemeIpt">
          <div  class="schemeIptLeft"> <span>*</span> 姓名</div>
          <input type="text" v-model.trim="form.Name"  placeholder="  请输入姓名" required>
        </div>
        <div class="schemeIpt">
          <div  class="schemeIptLeft"> <span>*</span> 公司</div>
          <input type="text" v-model.trim="form.CompanyName "  placeholder="  请输入公司" required>
        </div>
        <div class="schemeBtn">
            <button>确认提交</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { GainProject } from '@/api/navbar.js'
export default {
  props: ['showScheme'],
  data () {
    return {
      form: {},
      showHint: false // 手机格式错误显示
    }
  },
  methods: {
    async submit () {
      console.log('this.form', this.form)
      if (this.showHint) {
        return false
      }
      // 表格空返回
      if (JSON.stringify(this.form) === '{}') {
        return false
      }
      const res = await GainProject(this.form)
      if(res.Code === 0){
        this.$message({
          message: res.Msg,
          type: 'success'
        })
        this.closeBtn()
      }else{

      }
    },
    closeBtn () {
      this.$emit('SetShowScheme', false)
      this.form={}
    },
        // 获取焦点
    getIpt () {
      this.showHint = false
    },
        // input失去焦点校验
    leave (data) {
      // console.log(data, 'data')
      const tel = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/
      if (tel.test(data)) {
        // console.log('1111111')
      } else {
        // console.log('22222222')
        this.form.Phone='格式有误'
        this.showHint = true
      }
    },
  }
}
</script>

<style lang="scss" scoped>
$sun:100/192;
.GetScheme{
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.2);
}
.SchemeBox{
  width: 874px*$sun;
  height: 472px*$sun;
  background: #fff;
  margin: auto;
  margin-top: 150px*$sun;
}
.showHint{
  color: red;
}
.SchemeTitle{
  // width: 178px*$sun;
  width: 100%;
  height: 46px*$sun;
  font-size: 22px*$sun;
  font-weight: 500;
  line-height: 47px*$sun;
  background: #2380E1;
  color: #FFFFFF;
  text-align: center;
  margin-bottom: 40px*$sun;
  .closeBtn{
    float: right;
    width: 30px*$sun;
    height: 30px*$sun;
    margin: 8px*$sun 20px*$sun;
    cursor: pointer;
    img{
      width: 100%;
      height: 100%;cursor: pointer;
    }

  }
}
.schemeIpt{
  width: 778px*$sun;
  height: 41px*$sun;
  margin: auto;
  margin-bottom: 32px*$sun;
  position: relative;
  .schemeIptLeft{
    float: left;
    font-size: 18px*$sun;
    font-weight: 500;
    line-height: 41px*$sun;
    text-align: center;
    color: #000000;
    span{
      color: red;
    }
  }
  input{
    float: right;
    border: none;
    cursor: pointer;
    width: 653px*$sun;
    height: 41px*$sun;
    background: #FFFFFF;
    border: 2px*$sun solid #EEEEEE;
    border-radius: 4px*$sun;
    outline: none;
    font-size: 16px*$sun;
  }
  .getVerify{
    position: absolute;
    right: 0;
    /* 清除默认边框 */
      border:0;
      outline:none;
      /*清除默认背景 */
      background-color: transparent;
      color: #FFFFFF;
      background: #2380E1;
      font-size: 16px*$sun;
       font-weight: 500;
      width: 132px*$sun;
       height: 41px*$sun;
      border-radius: 0px 4px*$sun 4px*$sun 0px;
  }
}
.schemeBtn{
  width: 272px*$sun;
  height: 47px*$sun;
  margin: auto;
  margin-top: 70px*$sun;
  button{
    /* 清除默认边框 */
      border:0;
      outline:none;
      /*清除默认背景 */
      background-color: transparent;
      color: #FFFFFF;
      background: #2380E1;
      font-size: 18px*$sun;
      font-weight: 500;
      width:100%;
      height: 100%;
      border-radius:6px*$sun;
  }

}
</style>
